<template>
	<page>
		<module title="自定义编号规则" enable-flex>
			<c-table ref="list" height="grow" :paging="false">
				<c-table-column
					label="目标表单名称"
					name="form_type_name"
					width="300"
				></c-table-column>

				<c-table-column
					label="表单编号生成规则"
					name="code_rule"
					width="200"
				></c-table-column>

				<c-table-column
					label="编辑时间"
					name="edit_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="60"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_custom_seqnumber_edit')" v-lock="lock('b_custom_seqnumber_edit')" icon="tf-edit" @click="$refs.numberRuleEdit.open(data)">编辑</c-table-button>
					</template>
				</c-table-column>
			</c-table>

			<number-rule-edit ref="numberRuleEdit" @resolve="$refs.list.update()"></number-rule-edit>
		</module>
	</page>
</template>

<script>
	import numberRuleEdit from './number_rule_edit.vue'

	export default {
		components: {
			numberRuleEdit
		},

		data() {
			return {
			}
		},

		computed: {
		},

		mounted() {
			this.update();
		},

		methods: {
			update() {
				this.$refs.list.load({
					url: '/seq/list'
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>